import { render } from "./SetPasswordForm.vue?vue&type=template&id=64e2ae40&ts=true"
import script from "./SetPasswordForm.vue?vue&type=script&lang=ts"
export * from "./SetPasswordForm.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__